
  <dx-popup class="popup"
            [showTitle]="true"
            [title]="'Dateien hochladen'"
            [dragEnabled]="false"
            [height]="'50%'"
            [width]="'50%'"
            [hideOnOutsideClick]="false"
            (onShowing)="onShowingPopup($event)"
            (onHidden)="onHiddenPopup($event)"
            [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">
      <dx-scroll-view #scrollView
                      id="scrollview"
                      [scrollByContent]="true"
                      [scrollByThumb]="true"
                      [showScrollbar]="'onHover'"
                      [bounceEnabled]="false"
                      reachBottomText="Updating...">
        <dx-form #form [(formData)]="uploadContext">
          <dxi-item dataField="bezeichnung" [label]="{text: 'Bezeichnung'}">
            <dxi-validation-rule type="required" message="'Bezeichnung' wird benötigt!"></dxi-validation-rule>
          </dxi-item>
          <dxi-item name="info">
            <div class="well well-sm">
              <dx-file-uploader userRoleNeeded_hidden="Dokumente_Schreiben"
                                accept="application/rtf, text/plain, image/jpeg, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                [allowedFileExtensions]="allowedFileExtensions"
                                (onValueChanged)="addFile($event)"
                                [multiple]="true"
                                selectButtonText="Dateien auswählen (Auswahl mehrerer Dateien gleichzeitig möglich)"
                                #fileUploader
                                uploadMode="useForm">
              </dx-file-uploader>
            </div>
          </dxi-item>
        </dx-form>
      </dx-scroll-view>
    </div>

    <dxi-popup-toolbar-item widget="dxButton"
                      location="after"
                      toolbar="bottom"
                      [options]="{
            disabled: canUpload,
            text: 'Hochladen',
            onClick: onClickUebernehmen
        }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton"
                      location="after"
                      toolbar="bottom"
                      [options]="{
            text: 'Abbrechen',
            onClick: onClickClose
        }">
    </dxi-popup-toolbar-item>

  </dx-popup>

  <cz-upload-wait (onCancel)="onUploadCancel($event)" [uploadFileName]="uploadFileName" [toUpload]="toUpload" [isUploaded]="isUploaded" [(popupVisible)]="uploadWaitPopupVisible"></cz-upload-wait>
